"use client";
import useResponsive from "@/app/hooks/useResponsive";
import DisplaySize from "@/app/utils/DisplaySize";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Input } from "antd";
import { ChangeEvent, FC, memo, useState } from "react";

interface SearchInputProps {
  openSearchModal: boolean;
  setOpenSearchModal: (open: boolean) => void;
  handleSearchTextChange: (text: string) => void;
}

const SearchInput: FC<SearchInputProps> = ({ openSearchModal, setOpenSearchModal, handleSearchTextChange }) => {
  const [inputValue, setInputValue] = useState("");
  const screenSize = useResponsive();
  const isMobile = screenSize < DisplaySize.Tablet;

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    handleSearchTextChange(newValue);
  };

  const handleCloseSearch = () => {
    setOpenSearchModal(false);
    setInputValue("");
    handleSearchTextChange("");
  };

  return (
    <div className={`${openSearchModal ? "w-full mr-2 flex items-center gap-2 md:gap-6" : ""}`}>
      <Button
        type="text"
        size="large"
        icon={<SearchOutlined className="text-xl" />}
        onClick={() => setOpenSearchModal(true)}
      />
      <Input
        size={openSearchModal ? "large" : "middle"}
        placeholder="Search for Coin, Function, Announcement..."
        prefix={<SearchOutlined className="text-gray-400" />}
        className={`rounded-full bg-white border-gray-300 text-gray-600 placeholder-gray-400 text-sm md:text-base ${
          !openSearchModal ? "hidden" : ""
        }`}
        onChange={handleInputChange}
        value={inputValue}
      />
      {openSearchModal && (
        <Button
          size={isMobile ? "middle" : "large"}
          type="primary"
          className="lg:px-2"
          icon={<CloseOutlined />}
          onClick={handleCloseSearch}
        />
      )}
    </div>
  );
};

SearchInput.displayName = "SearchInput";

export default memo(SearchInput);
